import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { UserToken } from 'src/app/core/auth.model';
import { BreadcrumbService } from 'src/app/layout/topbar/app.breadcrumb.service';
import { BreadCrumb } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.model';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { MessageService } from 'primeng/api';
import { ConstantsService } from 'src/app/core/services/constants.service';
import { WoOrderServiceDefault } from 'src/app/models/response/wo-order-service-default.model';
import { WoOrderServiceDefaultService } from '../wo-order-service-default.service';

@Component({
  selector: 'sf-wo-order-service-default-detail',
  templateUrl: './wo-order-service-default-detail.component.html',
  styleUrls: ['./wo-order-service-default-detail.component.scss']
})
export class WoOrderServiceDefaultDetailComponent implements OnInit {

  @Input() id: string;
  public user$: Observable<UserToken>;
  public user?: UserToken;
  public item: WoOrderServiceDefault = {};

  public classBtnUpd: string = "p-button p-button-success p-m-1 mr-1";
  public classBtnDel: string = "p-button p-button-warning p-m-1 mr-1";
  public showValueB: boolean = false;
  public showTaxA: boolean = true;
  public showTaxB: boolean = false;
  public showRange: boolean = true;
  public labelUnitValueA: string = "";
  public labelUnitValueB: string = "";
  public labelUnitValueTaxA: string = "";
  public labelUnitValueTaxB: string = "";
  public labelUnitValueTaxApp: string = "";
  public labelUnitValueTaxPay: string = "";

  public language: string = "pt-BR";
  public pageMessage: string = "";
  public displayDialog: boolean = false;
  public submitted: boolean = false;
  public canUpdate: boolean = false;
  public isLoading: boolean = true;
  public isCartorio: boolean = false;
  public dialogHeader: string = "";

  public BREAD_CRUMB_LIST: Array<BreadCrumb> = [
    { label: 'Configuração', routerLink: '/', selected: false },
    { label: 'Serviços Padrão', routerLink: '/wo-order-service-default', selected: true }
  ];

  @Output() closeDialog = new EventEmitter();

  constructor(
    private translateService: TranslateService,
    private breadcrumbService: BreadcrumbService,
    private translateConfigService: TranslateConfigService,
    private userTokenService: UserTokenService,
    private messageService: MessageService,
    private constantsService: ConstantsService,
    private orderServiceDefaultService: WoOrderServiceDefaultService
  ) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.language = this.translateConfigService.getLanguage();
    this.user$ = this.userTokenService.getUser();

    this.user$.subscribe({
      next: (data) => { this.user = data; }
    });

    this.isCartorio = true;
    this.canUpdate = this.userTokenService.hasPermissionArray(['SF_ADMIN', 'SF_SELLER', 'ROLE_ADMIN', 'ROLE_MANAGER']);

    this.getItem();
    this.translate();

    if (this.canUpdate == false) {
      this.classBtnDel = "p-button p-button-secondary p-m-1 mr-1";
    }
  }

  getItem() {
    this.orderServiceDefaultService.getItem(this.id).subscribe(
      {
        next: (res) => {
          if (res)
            this.item = res.data;
          this.isLoading = false;
        },
        error: (err) => {
          this.messageError(this.translateService.instant('api_response.ERROR'));
          console.log(`WoOrderServiceDefaultDetailComponent - getItem : ${err}.`);
        }
      });
  }

  translate() {
    const sleep = (ms) => new Promise(r => setTimeout(r, ms));

    (async () => {
      await sleep(100);
      const labA = this.translateService.instant('label.services') + " ";
      const labB = " " + this.translateService.instant('label.serviceDefault');
      this.breadcrumbService.setItems([{ label: labA }, { label: labB, routerLink: ['wo-order-service-default'] }]);
      this.pageMessage = this.translateService.instant('grid.showing') + " {first} " + this.translateService.instant('grid.to') + " {last} " + this.translateService.instant('grid.of') + " {totalRecords} " + this.translateService.instant('grid.entries');
      this.dialogHeader = this.translateService.instant('title.woOrderServiceDefaultEdit');

      if (this.isCartorio) {
        this.showValueB = this.showTaxA = this.showTaxB = this.showRange = true;
        this.labelUnitValueA = "Recompe";
        this.labelUnitValueB = "Emolumentos";
        this.labelUnitValueTaxA = "Fiscalização";
        this.labelUnitValueTaxB = "ISS";
        this.labelUnitValueTaxApp = "Taxa App";
        this.labelUnitValueTaxPay = "Taxa Pay";
      }
      else {
        this.showValueB = (this.user.ScCompanyConfig.includes("UNIT_VALUE_B"));
        this.showTaxA = (this.user.ScCompanyConfig.includes("UNIT_VALUE_TAX_A"));
        this.showTaxB = (this.user.ScCompanyConfig.includes("UNIT_VALUE_TAX_B"));
        this.showRange = (this.user.ScCompanyConfig.includes("RANGE_VALUE"));

        this.labelUnitValueA = this.translateService.instant('label.unitValue');
        this.labelUnitValueB = this.translateService.instant('label.unitValueAux');
        this.labelUnitValueTaxA = this.translateService.instant('label.unitTaxValue');
        this.labelUnitValueTaxB = this.translateService.instant('label.unitTaxValueAux');
        this.labelUnitValueTaxApp = this.translateService.instant('label.unitTaxApp');
        this.labelUnitValueTaxPay = this.translateService.instant('label.unitTaxPay');
      }
    })();
  }

  messageSuccess(message: string) {
    this.messageService.add({ severity: this.constantsService.SEVERITY_SUCCESS, summary: this.translateService.instant('title.success'), detail: this.translateService.instant(message), life: 3000 });
  }

  messageError(message: string) {
    this.messageService.add({ severity: this.constantsService.SEVERITY_WARNING, summary: this.translateService.instant('title.error'), detail: this.translateService.instant(message), life: 3000 });
  }

  saveItem() {
    this.submitted = true;
    if (this.item.code && this.item.code.trim()) {
      if (this.item.id) {
        this.orderServiceDefaultService
          .updItem(this.item)
          .subscribe(
            {
              next: () => {
                this.messageSuccess(this.translateService.instant('message.record_updated'));
                this.isLoading = true;
              },
              error: (err) => {
                this.messageError(this.translateService.instant('api_response.ERROR'));
                console.log(`WoOrderServiceDefaultDetailComponent - updItem : ${err}.`);
              }
            });

      } else {
        this.orderServiceDefaultService
          .addItem(this.item)
          .subscribe(
            {
              next: () => {
                this.messageSuccess(this.translateService.instant('message.record_inserted'));
                this.isLoading = true;
              },
              error: (err) => {
                this.messageError(this.translateService.instant('api_response.ERROR'));
                console.log(`WoOrderServiceDefaultDetailComponent - addItem : ${err}.`);
              }
            });
      }

      this.displayDialog = false;
      this.submitted = false;
      this.item = {};
    }
  }

  hideDialog() {
    this.displayDialog = false;
    this.submitted = false;
    this.closeDialog.emit();
  }
}

